import { Component, EventEmitter, Output } from '@angular/core';
import { BaseComponent, RadioGroupComponent, WaitButtonComponent } from '@sircon/sircon-ui-framework';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-sign-in-help-options',
    templateUrl: './sign-in-help-options.component.html',
    styleUrls: ['./sign-in-help-options.component.less'],
    imports: [RadioGroupComponent, FormsModule, WaitButtonComponent]
})
export class SignInHelpOptionsComponent extends BaseComponent {
    @Output() resetPassword = new EventEmitter();
    @Output() recoverAccountId = new EventEmitter();

    helpOptions = [
        { stateName: 'forgotPassword', description: 'Forgot password' },
        { stateName: 'lostAccountId', description: 'Lost Account ID' }
    ];

    helpOption = '';
    submitting = false;

    submit() {
        this.submitting = true;
        if (this.helpOption === 'forgotPassword') {
            this.resetPassword.emit();
        } else if (this.helpOption === 'lostAccountId') {
            this.recoverAccountId.emit();
        }
    }

    goBack() {
        window.history.back();
    }
}
